import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('kby_lang') || 'th');

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('kby_lang', newLang);
  }, []);

  // Translate static UI strings by key
  const t = useCallback((key) => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry.en || key;
  }, [lang]);

  // Get field from data object with _th fallback
  const getField = useCallback((item, field) => {
    if (!item) return '';
    if (lang === 'th') {
      const thValue = item[field + '_th'] || item[field + 'Th'];
      if (thValue) return thValue;
    }
    return item[field] || '';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t, getField }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
